var _path;
import * as React from "react";
function SvgCompass(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.448 11.862l-9.313 4.256a2.06 2.06 0 00-1.017 1.018l-4.256 9.312c-.491 1.074.615 2.181 1.69 1.69l9.313-4.256a2.06 2.06 0 001.017-1.018l4.256-9.312c.491-1.075-.615-2.181-1.69-1.69zm-4.991 9.595a2.06 2.06 0 11-2.914-2.914 2.06 2.06 0 012.914 2.914zM20 4C11.163 4 4 11.163 4 20s7.163 16 16 16 16-7.163 16-16S28.837 4 20 4zm0 28.903c-7.115 0-12.903-5.788-12.903-12.903S12.885 7.097 20 7.097 32.903 12.885 32.903 20 27.115 32.903 20 32.903z"
  })));
}
export default SvgCompass;